import { render, staticRenderFns } from "./irrigationEfficiency.vue?vue&type=template&id=04c80cd4&scoped=true"
import script from "./irrigationEfficiency.vue?vue&type=script&lang=js"
export * from "./irrigationEfficiency.vue?vue&type=script&lang=js"
import style0 from "./irrigationEfficiency.vue?vue&type=style&index=0&id=04c80cd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c80cd4",
  null
  
)

export default component.exports